import { createEvent, createStore, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'
import { Bonus150Participant } from './types'
import {
  banParticipantTriggered,
  unbanParticipantTriggered,
  updateParticipantFx,
} from '../../../promo/bonus150/participants/list/model'

export const bonus150Mounted = createEvent()
export const setBonus150RequestError = createEvent<RequestError>()

export const getBonus150Participant = fx<void, Bonus150Participant>({
  method: 'GET',
  url: '/bonus150/participant/{clientID}',
})

export const $bonus150 = createStore<Bonus150Participant | null>(null).on(
  getBonus150Participant.doneData,
  (_, doneData) => doneData.body,
)

export const $bonus150Error = restore(setBonus150RequestError, {
  message: '',
  code: 0,
})

sample({
  clock: [bonus150Mounted, updateParticipantFx.doneData],
  source: $params,
  fn: (params) => ({
    url: `/bonus150/participant/${params?.clientID}`,
  }),
  target: getBonus150Participant,
})

sample({
  clock: getBonus150Participant.failData,
  fn: (failData) => ({ message: failData.body.message, code: failData.status }),
  target: setBonus150RequestError,
})

export {
  banParticipantTriggered,
  unbanParticipantTriggered,
  updateParticipantFx,
}
